import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft, Video } from "lucide-react";
import { Toaster } from "sonner";
import { useAuth } from "../context/AuthContext";
import { MeetingsPanel } from "../components/Meetings";

/**
 * Dedicated Meetings inbox — /account/meetings.
 *
 * Every logged-in active partner sees their own upcoming + past calls here.
 * The "Schedule" button on the panel is shown for all users but the backend
 * enforces who is actually allowed to invite — non-eligible hosts get a
 * friendly empty-network message inside the dialog rather than a hard 403.
 */
export default function AccountMeetings() {
  const { user, api } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!user) return;
    if (user.role === "admin") return;
    if ((user.status || "pending_kyc") !== "active") {
      nav("/verification-pending", { replace: true });
    }
  }, [user, nav]);

  return (
    <div className="min-h-screen bg-[#070707] text-[#F5F5F0] px-6 md:px-12 py-16">
      <Toaster position="bottom-right" theme="dark" richColors />
      <div className="max-w-[1100px] mx-auto">
        <Link to="/account" data-testid="meetings-back"
              className="inline-flex items-center gap-2 text-[#8A8A82] hover:text-[#B87333] text-xs uppercase tracking-[0.2em] font-grotesk mb-6">
          <ArrowLeft className="w-4 h-4" /> Back to Account
        </Link>
        <div className="mb-6">
          <div className="overline text-[#B87333] mb-2 inline-flex items-center gap-2">
            <Video size={12}/> Vinci Meeting Desk
          </div>
          <h1 className="font-serif text-4xl md:text-5xl">Your meetings</h1>
          <p className="font-body text-sm text-[#8A8A82] mt-3 max-w-2xl">
            Schedule secure video calls with your Vinci network. Each meeting spins up a unique,
            browser-native Jitsi room and delivers a professional invite to both parties instantly.
          </p>
        </div>
        <MeetingsPanel api={api} embedded />
      </div>
    </div>
  );
}
